import { FC } from 'react';
import _ from 'lodash';
import { useTranslation } from '@wix/fe-essentials-standalone';
import {
  StarsRatingBar,
  starRatingBarValue,
  Box,
  Text,
  starRatingBarSize,
  TextSize,
  TextWeight,
} from '@wix/design-system';
import s from './StarsRating.module.scss';

const StarBarAndRating: FC<{
  overallScore: number;
  showNumericalRating?: boolean;
  size?: starRatingBarSize;
  className?: string;
  numericalRatings: {
    size?: TextSize;
    className?: string;
    weight?: TextWeight;
  };
}> = ({
  size,
  overallScore,
  showNumericalRating = true,
  className,
  numericalRatings,
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <Box marginBottom="4px" verticalAlign="middle">
      <StarsRatingBar
        className={`${className || ''} ${s.starRatingBar}`}
        value={Math.round(overallScore) as starRatingBarValue}
        size={size ?? 'small'}
        readOnly
      />
      {showNumericalRating ? (
        <Box className={numericalRatings.className ?? ''} marginLeft="SP1">
          <Text
            size={numericalRatings.size ?? 'tiny'}
            weight={numericalRatings.weight ?? 'bold'}
            className={s.colorD20}
          >
            {Math.round(overallScore)}
          </Text>
        </Box>
      ) : null}
    </Box>
  );
};

export default StarBarAndRating;
